import { render, staticRenderFns } from "./seo-assessor.vue?vue&type=template&id=1370f571"
import script from "./seo-assessor.vue?vue&type=script&lang=js"
export * from "./seo-assessor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports